import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { adminApi, type CreateUserInput } from '../api/admin.api.js';

const KEY = ['admin', 'users'];

export function useAdminUsers() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => adminApi.listUsers(),
    staleTime: 60 * 1000,
  });
}

export function useCreateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateUserInput) => adminApi.createUser(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}
